/* GameEditorViewActionsRenderer.js */

"use strict";
const LockToggleComponent = require("../locktogglecomponent/LockToggleComponent");
const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;

class GameEditorViewActionsRenderer {
    constructor(model) {
        this._model = model;
        this._logger = this._model.logger;
        this._rootElem = document.createElement("game-editor-view-actions-gl");
        this._rootElem.component = this._model;

        this._leftContainer = document.createElement("left-container");
        this._dividerElem = document.createElement("div");
        this._dividerElem.classList.add("divider");
        this._rightContainer = document.createElement("right-container");

        this._renderedVaCollection = [];
        this._registerListeners();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _registerListeners() {
        this.model.on(
            "NewViewActions",
            (this._onNewViewActions = this._onNewViewActions.bind(this))
        );
        this.model.on(
            "ViewActionAdded",
            (this._onViewActionAdded = this._onViewActionAdded.bind(this))
        );
        this.model.on(
            "ViewActionRemoved",
            (this._onViewActionRemoved = this._onViewActionRemoved.bind(this))
        );
        this.model.on(
            "EnableViewAction",
            (this._onEnableViewAction = this._onEnableViewAction.bind(this))
        );
        this.model.on(
            "DisableViewAction",
            (this._onDisableViewAction = this._onDisableViewAction.bind(this))
        );
        this.model.on(
            "ShowViewAction",
            (this._onShowViewAction = this._onShowViewAction.bind(this))
        );
        this.model.on(
            "HideViewAction",
            (this._onHideViewAction = this._onHideViewAction.bind(this))
        );
    }
    _unregisterListeners() {
        this.model
            .removeAllListeners("NewViewActions")
            .removeAllListeners("ViewActionAdded")
            .removeAllListeners("ViewActionRemoved")
            .removeAllListeners("EnableViewAction")
            .removeAllListeners("DisableViewAction")
            .removeAllListeners("ShowViewAction")
            .removeAllListeners("HideViewAction");
    }
    _onNewViewActions() {
        return this.render();
    }
    _onViewActionAdded(actionDef) {
        this._addViewAction(actionDef);
    }
    _onViewActionRemoved(vaInfo) {
        this._removeViewAction(vaInfo.name);
    }
    _onShowViewAction(vaName) {
        if (this._renderedVaCollection.length > 0) {
            this._renderedVaCollection.forEach((cmpnt) => {
                if (cmpnt.value === vaName) {
                    cmpnt.renderer.rootElement.style.display = "";
                }
            });
        }
    }
    _onHideViewAction(vaName) {
        if (this._renderedVaCollection.length > 0) {
            this._renderedVaCollection.forEach((cmpnt) => {
                if (cmpnt.value === vaName) {
                    cmpnt.renderer.rootElement.style.display = "none";
                }
            });
        }
    }
    _onEnableViewAction(vaName) {
        if (this._renderedVaCollection.length > 0) {
            this._renderedVaCollection.forEach((cmpnt) => {
                if (cmpnt.value === vaName) {
                    cmpnt.disabled = false;
                }
            });
        }
    }
    _onDisableViewAction(vaName) {
        if (this._renderedVaCollection.length > 0) {
            this._renderedVaCollection.forEach((cmpnt) => {
                if (cmpnt.value === vaName) {
                    cmpnt.disabled = true;
                }
            });
        }
    }
    _clearViewActionButtons() {
        let promArr = [];
        if (this._renderedVaCollection.length > 0) {
            this._renderedVaCollection.forEach((cmpnt) => {
                promArr.push(this._removeViewActionCmpnt(cmpnt));
            });
        } else {
            promArr.push(Promise.resolve());
        }
        return Promise.all(promArr)
            .then(() => {
                this._renderedVaCollection = [];
                while (this._rightContainer.hasChildNodes()) {
                    this._rightContainer.removeChild(this._rightContainer.firstChild);
                }
                while (this._leftContainer.hasChildNodes()) {
                    this._leftContainer.removeChild(this._leftContainer.firstChild);
                }
                return Promise.resolve();
            })
            .catch((err) => {
                this._logger.warn(err, "GameEditorFooterRenderer._clearViewActionButtons error.");
                return Promise.reject(err);
            });
    }
    _renderViewActions() {
        return this._clearViewActionButtons().then(() => {
            // The component may have shut down (model cleared) while this render was
            // in flight — e.g. a fast tab switch away from a view that registers its
            // actions asynchronously. Nothing to render in that case.
            let regViewActions = this.model ? this.model.registeredViewActions : undefined;
            if (!regViewActions) {
                return Promise.resolve();
            }
            if (regViewActions.length > 0) {
                regViewActions.forEach((vaInfo) => {
                    this._addViewAction(vaInfo);
                });
                return Promise.resolve();
            } else {
                // this._rootElem.style.display = 'none';
                return Promise.resolve();
            }
        });
    }
    _addViewAction(vaInfo) {
        if (vaInfo.type === "locktoggle") {
            let locktoggle = new LockToggleComponent(this._logger);
            locktoggle.on("UserClick", (val) => {
                this.model.requestViewAction(vaInfo.name, [val]);
            });
            locktoggle.setIsLocked(vaInfo.isLocked, true);
            this._leftContainer.appendChild(locktoggle.renderer.rootElement);
            locktoggle.renderer.render();
            this._renderedVaCollection.push(locktoggle);
        } else {
            let button = new ButtonControl({label: vaInfo.displayName, value: vaInfo.name});
            button.on("UserClick", () => {
                this.model.requestViewAction(vaInfo.name);
            });
            if (vaInfo.position === "left") {
                this._leftContainer.appendChild(button.renderer.rootElement);
            } else {
                this._rightContainer.appendChild(button.renderer.rootElement);
            }
            this._renderedVaCollection.push(button);
        }
    }
    _removeViewAction(name) {
        let cmpnt = this._renderedVaCollection.find((obj) => {
            return obj.value === name;
        });
        if (cmpnt) {
            return this._removeViewActionCmpnt(cmpnt);
        } else {
            return Promise.resolve();
        }
    }
    _removeViewActionCmpnt(cmpnt) {
        cmpnt.removeAllListeners("UserClick");
        return cmpnt.shutdown().then(() => {
            let index = this._renderedVaCollection.indexOf(cmpnt);
            this._renderedVaCollection.splice(index, 1);
            return Promise.resolve();
        });
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    shutdown() {
        this._unregisterListeners();

        return this._clearViewActionButtons().then(
            () => {
                this._renderedVaCollection = undefined;
                this._model = undefined;
                this._leftContainer.remove();
                this._dividerElem.remove();
                this._rightContainer.remove();
                this._leftContainer = undefined;
                this._rightContainer = undefined;
                this._dividerElem = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
            },
            (err) => {
                this._logger.warn(err, "Error in GameEditorFooterRenderer.shutdown()");
            }
        );
    }
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        if (!this._rootElem.hasChildNodes()) {
            this._rootElem.appendChild(this._leftContainer);
            this._rootElem.appendChild(this._dividerElem);
            this._rootElem.appendChild(this._rightContainer);
        }
        return this._renderViewActions();
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE RENDER METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE RENDER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}
module.exports = GameEditorViewActionsRenderer;
